import { Routes } from '@angular/router';
import {
  ACTIVITY_LOG_APP_BASE_URL,
  CONTACT_RESEARCH_BASE_URL,
  GLOBALSEARCH_BASE_URL,
  GROUP_BASE_URL,
  HOME_APP_BASE_URL,
  INTERNAL_COMMS_BASE_URL,
  OPPORTUNITIES_APP_BASE_URL,
  ORG_BASE_URL,
  PATIENT_PROFILE_APP_BASE_URL,
  PC_BASE_URL,
  PREF_MGT_BASE_URL,
  REPORTS_APP_BASE_URL,
  RXHUB_BASE_URL,
  STORE_BASE_URL,
  USER_ADMIN_BASE_URL
} from '@enliven/angular';
import { AlertComponent } from './components/alert/alert.component';
import { HomeComponent } from './components/home/home.component';
import { IframeComponent } from './components/iframe/iframe.component';
import { isAuthenticatedGuard } from './guards/is-authenticated.guard';
import { isAuthorizedGuard } from './guards/is-authorized.guard';
import { redirectToSignInGuard } from './guards/redirect-to-signin.guard';
import { createUserSessionResolver } from './resolvers/create-user-session.resolver';
import { errorMessageResolver } from './resolvers/error-message.resolver';
import { frameSourceResolver } from './resolvers/frame-source.resolver';
import { signOutMessageResolver } from './resolvers/sign-out-message.resolver';

export const routes: Routes = [
  {
    path: 'signin',
    loadComponent: () =>
      import('./components/sign-in-wrapper/sign-in-wrapper.component').then(mod => mod.SignInWrapperComponent)
  },
  {
    path: 'signin/forgotpassword',
    loadComponent: () =>
      import('./components/sign-in-wrapper/sign-in-wrapper.component').then(mod => mod.SignInWrapperComponent)
  },
  {
    path: 'app',
    component: HomeComponent,
    canActivate: [isAuthenticatedGuard, isAuthorizedGuard],
    resolve: { session: createUserSessionResolver },
    children: [
      {
        path: PATIENT_PROFILE_APP_BASE_URL,
        resolve: { frameSource: frameSourceResolver },
        children: [{ path: '**', component: IframeComponent }]
      },
      {
        path: STORE_BASE_URL,
        resolve: { frameSource: frameSourceResolver },
        children: [{ path: '**', component: IframeComponent }]
      },
      {
        path: GROUP_BASE_URL,
        resolve: { frameSource: frameSourceResolver },
        children: [{ path: '**', component: IframeComponent }]
      },
      {
        path: ORG_BASE_URL,
        resolve: { frameSource: frameSourceResolver },
        children: [{ path: '**', component: IframeComponent }]
      },
      {
        path: PC_BASE_URL,
        resolve: { frameSource: frameSourceResolver },
        children: [{ path: '**', component: IframeComponent }]
      },
      {
        path: PREF_MGT_BASE_URL,
        resolve: { frameSource: frameSourceResolver },
        children: [{ path: '**', component: IframeComponent }]
      },
      {
        path: USER_ADMIN_BASE_URL,
        resolve: { frameSource: frameSourceResolver },
        children: [{ path: '**', component: IframeComponent }]
      },
      {
        path: CONTACT_RESEARCH_BASE_URL,
        resolve: { frameSource: frameSourceResolver },
        children: [{ path: '**', component: IframeComponent }]
      },
      {
        path: OPPORTUNITIES_APP_BASE_URL,
        resolve: { frameSource: frameSourceResolver },
        children: [{ path: '**', component: IframeComponent }]
      },
      {
        path: REPORTS_APP_BASE_URL,
        resolve: { frameSource: frameSourceResolver },
        children: [{ path: '**', component: IframeComponent }]
      },
      {
        path: HOME_APP_BASE_URL,
        resolve: { frameSource: frameSourceResolver },
        children: [{ path: '**', component: IframeComponent }]
      },
      {
        path: ACTIVITY_LOG_APP_BASE_URL,
        resolve: { frameSource: frameSourceResolver },
        children: [{ path: '**', component: IframeComponent }]
      },
      {
        path: INTERNAL_COMMS_BASE_URL,
        resolve: { frameSource: frameSourceResolver },
        children: [{ path: '**', component: IframeComponent }]
      },
      {
        path: GLOBALSEARCH_BASE_URL,
        resolve: { frameSource: frameSourceResolver },
        children: [{ path: '**', component: IframeComponent }]
      },
      {
        path: `${RXHUB_BASE_URL}`,
        resolve: { frameSource: frameSourceResolver },
        children: [{ path: '**', component: IframeComponent }]
      }
    ]
  },
  { path: 'error', component: AlertComponent, resolve: { message: errorMessageResolver } },
  { path: 'signout', component: AlertComponent, resolve: { message: signOutMessageResolver } },
  { path: '', canActivate: [redirectToSignInGuard], children: [] },
  { path: '**', redirectTo: 'error' }
];
